import { usersListResponse } from "types/userInfo";
import { getAssetList } from "./assets.api";
import { GetUsers } from "./users.api";
import { AssetListResponse } from "types/asset";

export function getMapAssets(venueID: string | null, params?: Record<string, any>): Promise<AssetListResponse> {

  return getAssetList({
    limit: 200,
    has_location_filter: 'true',
    venue_id_filter: venueID,
    ...params
  })
  // .then(res => {
  //   res.items.forEach(r => r.location = {
  //     "venue": {
  //       "id": "5e417c00-1023-4ca7-9d1b-0e4ce5c80fca",
  //       "name": "cumberlandinfirmary"
  //     },
  //     "region": {
  //       "id": "646aea7e-ceb2-4379-8c42-58d46a48b808",
  //       "name": "A&E Treatment Room 1A-4A",
  //     },
  //     "coordinates": {
  //       "latitude": random(54.89615087764397, 54.89699997764397),
  //       "longitude": random(-2.9581268886953555, -2.9589999996953555)
  //     },
  //     "uncertainty": 9.153183175800523,
  //     "is_outdoors": false,
  //     "building_level": {
  //       "possible_buildings": [
  //         {
  //           "id": "3cc3c63b-c5e5-471c-891e-9f652965f41b",
  //           "name": "Main"
  //         }
  //       ],
  //       "level": {
  //         "id": "0e556a57-3efe-425d-aa02-fb19f7b70130",
  //         "name": "Floor 0",
  //         "short_name": "0"
  //       },
  //     }
  //   }
  //   )
  //   return res
  // })
};

export function getMapUsers(venueID: string | null, params?: Record<string, any>): Promise<usersListResponse> {

  return GetUsers({
    venue_id_filter: venueID,
    ...params,
    limit: 200
  })
};
